import React, {useEffect} from 'react';
import Button from '../button/Button';
import './inputWithCharacterCounter.scss';

export enum COMPARISON_TYPE {
    GREATER_THAN,
    GREATER_THAN_OR_EQUAL,
}

export interface CharacterCounterProps {
    value: string;
    onChange: (value: string) => void;
    onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    placeholder?: string;
    className?: string;
    maxLength?: number;
    onLimitChange?: (isOverLimit: boolean) => void;
    disabled?: boolean;
    comparisonType?: COMPARISON_TYPE;
    dataCy?: string;
    leading?: string;
    trailing?: JSX.Element;
    inlineMaxLength?: boolean;
}

function InputWithCharacterCounter({
    maxLength = 0,
    value,
    onChange,
    onKeyUp,
    placeholder,
    className,
    onLimitChange,
    disabled,
    comparisonType = COMPARISON_TYPE.GREATER_THAN_OR_EQUAL,
    dataCy,
    leading,
    trailing,
    inlineMaxLength,
}: CharacterCounterProps): JSX.Element {
    const isOverLimit = comparisonType === COMPARISON_TYPE.GREATER_THAN ? value.length > maxLength : value.length >= maxLength;

    useEffect(() => {
        if (onLimitChange) {
            onLimitChange(isOverLimit);
        }
    }, [isOverLimit, onLimitChange]);

    return (
        <>
            <div className={`c-inputWithCharacterCounter ${className || ''}`}>
                {leading && (
                    <Button
                        className="c-inputWithCharacterCounter__leading"
                        leading={leading}
                        size="xs"
                        variant="ghost"
                        square
                        disablePointerEvents
                    />
                )}
                <input
                    className="c-inputWithCharacterCounter__field"
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyUp={onKeyUp}
                    disabled={disabled}
                    data-cy={dataCy}
                />
                <div className="c-inputWithCharacterCounter__trailing">{trailing}</div>
                {inlineMaxLength && maxLength > 0 && (
                    <div className={`c-characterCounter__inline ${isOverLimit ? 'c-characterCounter--alert' : ''}`}>
                        {value.length}/{maxLength}
                    </div>
                )}
            </div>
            {!inlineMaxLength && maxLength > 0 && (
                <div className={`c-characterCounter ${isOverLimit ? 'c-characterCounter--alert' : ''}`}>
                    {value.length}/{maxLength}
                </div>
            )}
        </>
    );
}

export default InputWithCharacterCounter;
